import BaseClass from "./BaseClass";

const defaultOptions = {};

export default class cardCheck extends BaseClass {
  constructor(options) {
    super(options, defaultOptions);

    this.init();
  }

  init() {
    $(document).ready(function() {
      if ($("[data-card]").length > 0) {
        cardCheck.expirationFormat();
        cardCheck.getBankType();
      }
    });
  }

  /**
   * this function check if credit card have good format if not submit form is disable
   *
   * @param {JQueryEventObject} e
   */
  static checkCardValid(e = null) {
    let card = $("[data-card]");
    if($(card).length <= 0) {
      return true;
    }

    let cardValue = $(card).val();

    let regex = new RegExp(
      "^(?:4[0-9]{12}(?:[0-9]{3})?|[25][1-7][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\\d{3})\\d{11})$"
    );

    cardValue = cardValue.replace(/\s/g, "");
    if (!regex.test(cardValue)) {
      $(card).addClass("error");
      $("[data-card-validation-text]").removeClass("hidden-mvio");
      return false;
    } else {
      $(card).removeClass("error");
      $("[data-card-validation-text]").addClass("hidden-mvio");
      return true;
    }
  }

  /**
   * this Function set expiration format
   */
  static expirationFormat() {
    let expiration;
    let isDelete = false;
    $("[data-card-expiration]").keyup(function() {
      expiration = $(this).val();

      if (expiration > 1 && expiration < 10) {
        if (!expiration.includes("0")) {
          expiration = "0" + expiration;
          $(this).val(expiration);
        }
      }
      if (expiration >= 13) {
        expiration = expiration.split("");
        expiration = "0" + expiration[0] + "/" + expiration[1];
        $(this).val(expiration);
      }

      if ((expiration.length === 2 && isDelete) || expiration.length === 3) {
        expiration = expiration.slice(0, -1);
        isDelete = false;
        $(this).val(expiration);
      }

      if (expiration.length === 2) {
        if (!expiration.includes("/")) {
          expiration = expiration + "/";
        } else {
          expiration = "0" + expiration;
        }

        isDelete = true;
        $(this).val(expiration);
      }
    });
  }

  /**
   * This function check if expiration have good format if not submit form is disable
   *
   * @param {JQueryEventObject} e
   */
  static checkExpirationValid(e = null) {
    let regex = new RegExp("^(0[1-9]|1[0-2])\\/?([0-9]{4}|[0-9]{2})$");
    let expiration = $("[data-card-expiration]");

    if($(expiration).length <= 0) {
      return true;
    }

    let expirationValue = $(expiration).val();

    let checkDate = false;
    let splitExpiration;
    let d = new Date();
    let m = d.getMonth();
    let currentYear = d.getFullYear();

    currentYear = currentYear.toString();
    currentYear = currentYear.slice(-2);
    currentYear = parseInt(currentYear);

    splitExpiration = expirationValue.split("/");
    let month = parseInt(splitExpiration[0]);
    let year = parseInt(splitExpiration[1]);

    if (year > currentYear) {
      checkDate = true;
    } else {
      if (month >= m + 1 && year === currentYear) {
        checkDate = true;
      }
    }

    if (!regex.test(expirationValue) || !checkDate) {
      $(expiration).addClass("error");
      $("[data-card-expiration-valid-text]").removeClass("hidden-mvio");
      return false;
    } else {
      $(expiration).removeClass("error");
      $("[data-card-expiration-valid-text]").addClass("hidden-mvio");
      return true;
    }
  }

  /**
   * this function check which type of bank is card
   */
  static getBankType() {
    let cardValue;
    let Visa = new RegExp("^4[0-9]{6,}$");
    let masterCard = new RegExp(
      "^5[1-5][0-9]{5,}|222[1-9][0-9]{3,}|22[3-9][0-9]{4,}|2[3-6][0-9]{5,}|27[01][0-9]{4,}|2720[0-9]{3,}$"
    );
    let americanExpress = new RegExp("^3[47][0-9]{5,}$");
    let dinersClub = new RegExp("^3(?:0[0-5]|[68][0-9])[0-9]{4,}$");
    let discover = new RegExp("^6(?:011|5[0-9]{2})[0-9]{3,}$");
    let jcb = new RegExp("^(?:2131|1800|35[0-9]{3})[0-9]{3,}$");

    $("[data-card]").keyup(function() {
      cardValue = $(this).val();
      cardValue = cardValue.replace(/\s/g, "");

      let dataBankIcon = $("[data-bank-icon]");
      $('[data-bank-icon-edit]').show();

      if (Visa.test(cardValue)) {
        $(dataBankIcon).removeClass();
        $(dataBankIcon).addClass("bank-icon bank-icon-visa");
      } else if (americanExpress.test(cardValue)) {
        $(dataBankIcon).removeClass();
        $(dataBankIcon).addClass("bank-icon bank-icon-american");
      } else if (dinersClub.test(cardValue)) {
        $(dataBankIcon).removeClass();
        $(dataBankIcon).addClass("bank-icon bank-icon-dinners");
      } else if (discover.test(cardValue)) {
        $(dataBankIcon).removeClass();
        $(dataBankIcon).addClass("bank-icon bank-icon-discover");
      } else if (jcb.test(cardValue)) {
        $(dataBankIcon).removeClass();
        $(dataBankIcon).addClass("bank-icon bank-icon-jcb");
      } else if (masterCard.test(cardValue)) {
        $(dataBankIcon).removeClass();
        $(dataBankIcon).addClass("bank-icon bank-icon-mastercard");
      } else {
        $(dataBankIcon).removeClass();
      }
    });
  }
}
